import { memo } from 'react';

import { TActionResultEntity, TActionResultStatus } from '~/src/entities/speed-bonus/context/actions/setResult';

import ErrorActivation from './Error/Activation';
import ErrorRequest from './Error/Request';
import SuccessActivation  from './SuccessActivation';
import SuccessRequest from './SuccessRequest';

type TResultFooter = {
    [E in Exclude<TActionResultEntity, 'none'>]: {
        [S in Exclude<TActionResultStatus, 'none'>]: JSX.Element;
    };
}

const FooterByEntityAndStatus: TResultFooter = {
    'activation': {
        'success': <SuccessActivation/>,
        'error': <ErrorActivation/>,
    },
    'request': {
        'success': <SuccessRequest/>,
        'error': <ErrorRequest/>,
    },
};

interface IProps {
    entity: TActionResultEntity,
    status: TActionResultStatus,
}

const ResultFooter = ({
    entity,
    status,
}: IProps): JSX.Element | null => (entity === 'none' || status === 'none')
    ? null
    : FooterByEntityAndStatus[entity][status];

export default memo(ResultFooter);
